import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  submitWrapper: {
    maxWidth: 500,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(2, 0)
  },
  formWrapper: {
    height: "100%"
  },
  formContainer: {
    flexDirection: "column",
    maxWidth: 500,
    margin: theme.spacing(1, 0)
  }
}));
